import { render } from "./Header.vue?vue&type=template&id=c0f2e294&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=c0f2e294&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/Israr/vue/matrixlimos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0f2e294"]])

export default __exports__